import type { LegacyRef } from 'react';
import { forwardRef, useRef, useState } from 'react';

interface FilePickerProps {
  filehandler: (value: File | null) => void;
  namehandler?: (value: string) => void;
}

function FilePicker(
  { filehandler, namehandler }: FilePickerProps,
  ref: LegacyRef<HTMLDivElement>
): JSX.Element {
  const [file, setFile] = useState<File | null>();
  // Ref object to reference the input element
  const inputFile = useRef<HTMLInputElement>(null);

  // Function to reset the input element
  const handleReset = () => {
    if (inputFile.current) {
      inputFile.current.value = '';
    }
  };

  const addFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files) {
      const file = Array.from(e.target.files)[0];
      filehandler(file as File);
      setFile(file);
    }
  };

  return (
    <div>
      <div className="image-picker uk-margin" ref={ref}>
        <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
          {namehandler && (
            <input
              className="uk-input uk-form-width-medium"
              id="uk-input"
              type="text"
              placeholder="Nom de la ressource"
              aria-label="Default"
              onChange={(e) => namehandler(e.target.value)}
              style={{ height: '40px' }}
            />
          )}
          <div uk-form-custom="true">
            <input
              ref={inputFile}
              type="file"
              aria-label="Custom controls"
              onChange={addFile}
              accept=""
            />
            <button
              className="uk-button uk-button-default"
              onClick={handleReset}
              type="button"
              tabIndex={-1}
            >
              Parcourir...
            </button>
          </div>
          {file && (
            <span>{`${
              file.name.length < 3
                ? file.name
                : `${file.name.substring(0, 3)}...`
            }`}</span>
          )}
        </div>
      </div>
      {file && (
        <div className="image-preview">
          <span
            className="trash"
            uk-icon="trash"
            onClick={() => {
              setFile(null);
              handleReset();
              filehandler(null);
            }}
          ></span>
          <div style={{ textAlign: 'center' }}>
            <img
              style={{ textAlign: 'center' }}
              className="image"
              src={URL.createObjectURL(file)}
              alt="Selected file preview"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default forwardRef(FilePicker);
